<template>
  <v-app-bar
    app
    color="white"
    light
    flat
    height="73"
    style="box-shadow: inset 0px -1px 0px #F5F5F5;"
  >
    <v-row class="d-flex justify-space-between align-center">
      <v-spacer></v-spacer>
      <v-col sm="3" class="d-flex justify-end align-center">
        <ProfileInfo :profileName="profileName" :profileEmail="profileEmail" />
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import ProfileInfo from "@/components/molecules/profile-info";

export default {
  components: { ProfileInfo },
  data() {
    return {
      profileName: "",
      profileEmail: ""
    };
  },
  beforeMount() {
    this.profileName = this.$store.state.user.name;
    this.profileEmail = this.$store.state.user.email;
  }
};
</script>

<style scoped>
</style>
